import axios from "axios";

export async function fetchAcademics() {
  const serverUrl = process.env.NEXT_PUBLIC_SERVER_URL;
  try {
    if (!serverUrl) {
      throw new Error("Server URL is not defined");
    }

    const response = await axios.get(`${serverUrl}/academics?populate=*`);
    return response.data;
  } catch (error) {
    console.error("Error fetching academics data:", error);
    return null;
  }
}

export async function fetchAcademicByName(name) {
  const serverUrl = process.env.NEXT_PUBLIC_SERVER_URL;

  try {
    if (!serverUrl) {
      throw new Error("Server URL is not defined");
    }

    const response = await axios.get(`${serverUrl}/academics`, {
      params: {
        filters: {
          Name: {
            $eq: name,
          },
        },
        populate: {
          Course: {
            populate: {
              featured_image: true,
              Course_Highlights: true,
              Brochure_Pdf: true,
              school: true,
              course: {
                fields: ["slug"],
              },
            },
          },
          School_Filters: true,
          Duration_Filters: true,
        },
      },
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching academic data for ${name}:`, error);
    return null;
  }
}
